class StringError extends Error {
	public readonly original: string;

	constructor(message: string) {
		super(message);
		this.name = 'StringError';
		this.original = message;
	}
}

export const throwStringError = (message: string): never => {
	throw new StringError(message);
};